// Manufacturing → Order Intake review surface (OI-3).
import { OrderIntakeReviewDetailDrawer } from "@/components/sales-intake/OrderIntakeReviewDetailDrawer";
import { OrderIntakeRowList, OrderIntakeTabBar } from "@/components/sales-intake/orderIntakeReviewList";

import { ManufacturingGateBanner } from "./ManufacturingGateBanner";
import { ManufacturingOrderIntakeCreateForm } from "./ManufacturingOrderIntakeCreateForm";
import { ManufacturingOrderIntakeIdeaRoomImport } from "./ManufacturingOrderIntakeIdeaRoomImport";
import { ManufacturingOrderIntakeSenseiImport } from "./ManufacturingOrderIntakeSenseiImport";
import { ghostBtnClass, primaryBtnClass } from "./ManufacturingOrderIntakeShared";
import { useManufacturingEntitlementGate } from "./useManufacturingEntitlementGate";
import { useManufacturingOrderIntake } from "./useManufacturingOrderIntake";

export function ManufacturingOrderIntakePanel() {
  const gate = useManufacturingEntitlementGate();
  const o = useManufacturingOrderIntake();

  return (
    <div className="w-full text-left space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">Order Intake</h2>
          <p className="text-xs text-gray-600 dark:text-zinc-400">
            Review incoming orders from inventory host, IdeaRoom, Sensei paste, in-app create, and dealer
            submissions. Accept materializes a deal + unit; Hold sends a clarification
            request; Cancel soft-archives for 30 days.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className={primaryBtnClass}
            onClick={() => o.setCreateOpen(!o.createOpen)}
            disabled={!gate.enabled || o.createBusy}
          >
            {o.createOpen ? "Close create form" : "+ Create order"}
          </button>
          <button
            type="button"
            className={ghostBtnClass}
            onClick={() => o.setImportOpen(!o.importOpen)}
            disabled={!gate.enabled || o.createBusy}
          >
            {o.importOpen ? "Close IdeaRoom import" : "Import IdeaRoom JSON"}
          </button>
          <button
            type="button"
            className={ghostBtnClass}
            onClick={() => o.setSenseiOpen(!o.senseiOpen)}
            disabled={!gate.enabled || o.createBusy}
          >
            {o.senseiOpen ? "Close Sensei import" : "Import Sensei JSON"}
          </button>
          <button
            type="button"
            className={ghostBtnClass}
            onClick={() => {
              gate.refresh();
              void o.refresh();
            }}
            disabled={gate.loading || o.loadingRows || o.actionBusy || o.createBusy}
          >
            {o.loadingRows ? "Refreshing…" : "Refresh"}
          </button>
        </div>
      </div>

      <ManufacturingGateBanner gate={gate} />

      {gate.enabled ? (
        <div className="space-y-4">
          {o.createOpen ? (
            <ManufacturingOrderIntakeCreateForm
              busy={o.createBusy}
              error={o.createError}
              onSubmit={o.submitCreate}
              onCancel={() => o.setCreateOpen(false)}
            />
          ) : null}
          {o.importOpen ? (
            <ManufacturingOrderIntakeIdeaRoomImport
              busy={o.createBusy}
              error={o.createError}
              onSubmit={o.submitIdeaRoomImport}
              onCancel={() => o.setImportOpen(false)}
            />
          ) : null}
          {o.senseiOpen ? (
            <ManufacturingOrderIntakeSenseiImport
              busy={o.createBusy}
              error={o.createError}
              onSubmit={o.submitSenseiImport}
              onCancel={() => o.setSenseiOpen(false)}
            />
          ) : null}

          <OrderIntakeTabBar activeTab={o.activeTab} onChange={o.setActiveTab} total={o.total} />

          {o.listError ? (
            <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-900 dark:border-red-800 dark:bg-red-950/35 dark:text-red-100">
              {o.listError}
            </div>
          ) : null}

          <OrderIntakeRowList
            rows={o.rows}
            loading={o.loadingRows}
            activeTab={o.activeTab}
            selectedId={o.selectedId}
            onSelect={o.setSelectedId}
          />

          {o.selectedRow ? (
            <OrderIntakeReviewDetailDrawer
              row={o.selectedRow}
              variant="mfg_accepter"
              onClose={() => o.setSelectedId(null)}
              actionBusy={o.actionBusy}
              actionError={o.actionError}
              onAccept={(plantOverride) => o.acceptSelected(plantOverride)}
              onHold={(reason) => o.holdSelected(reason)}
              onCancel={() => o.cancelSelected()}
              onReturnToHold={(reason) => o.returnSelectedToHold(reason)}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
